async function Balance(designid, userid) {

    if (designid.length > 0 && userid.length > 0) {

        let response;

        response = await fetch("https://api.cssi.co/CNF/BalanceDesign", {
            method: "POST",
            body: JSON.stringify(
                {
                    "designid": designid,
                    "userid": userid
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default Balance;